import { MasterDataService } from './../masterdata/masterdata.service';
import { Component, OnInit } from '@angular/core';
import { ApgDeliveryService } from '../apg-delivery/apg-delivery.service';
import { ApgNcSampleService } from '../apg-nc-sample/apg-nc-sample.service';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';
import { BoxDetails, ShipmentSample } from './boxDetails';
import { BoxStatus, SelectableBoxStatus } from './deliveryManagerPackage';
import { ShipmentBoxDetails, ShipmentBoxReception } from './shipmentBoxDetails';
import { DeliveryBoxDetails, DeliveryBoxReception } from './deliveryBoxDetails';
import { WorkFlow } from '../masterdata/models/workFlow';

@Component({
  selector: 'app-apg-deliver-box-manager',
  templateUrl: './apg-deliver-box-manager.component.html',
  styleUrls: ['./apg-deliver-box-manager.component.css']
})
export class ApgDeliverBoxManagerComponent implements OnInit {
  errorHandler: ErrorHandler = new ErrorHandler;
  selectedLabId: string;
  selectedLabName: string;
  boxIdValidated: boolean;
  boxStatusList: SelectableBoxStatus[];
  SelectableBoxStatus: SelectableBoxStatus;
  puid: string;
  index: number = 0;
  boxID:string ='';
  selectedSender:string;
  senderList: any[] = [];
  blocked=false;
  cols: any[];
  updateBoxBarcode: string;
  updateBoxSender: string;
  boxUpdateMessage: any = "";
  selectedBoxToEdit: ShipmentBoxDetails;
  senderBarcodeMap: Map<string,string>;  
  scannedShipmentBoxes:DeliveryBoxReception[] = [];
  deliveryBox: DeliveryBoxDetails;
  scannedShipmentBoxIds: Set<string>;
  workFlowData: WorkFlow[] = [];
  selectedWorkFlowData:WorkFlow[]=[];
  constructor(private ncSampleService: ApgNcSampleService, 
    private _messagesService: MessagesService, private deliveryService: ApgDeliveryService, 
    private masterDataService : MasterDataService) { 
  }

  ngOnInit() {
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    this.selectedLabName = JSON.parse(localStorage.getItem('lab')).lab.name;
    this.puid = localStorage.getItem('PUID');
    this.senderBarcodeMap = new Map<string, string>();
    this.populateSenders();
    this.getWorkFlowList();
    this.boxStatusList = [
      { name: 'New', value: BoxStatus.NEW },
      { name: 'Received ', value: BoxStatus.RECEIVED },
      { name: 'Missing ', value: BoxStatus.MISSING },
      { name: 'Unboxing', value: BoxStatus.UNBOXING },
      { name: 'Unboxing Complete', value: BoxStatus.UNBOXING_COMPLETE },
      { name: 'Empty ', value: BoxStatus.EMPTY },
      { name: 'Removed ', value: BoxStatus.REMOVED },
    ];
    this.cols = [
      { field: 'delivery', header: 'Delivery ID', width:'20%' }
    ];
    this.scannedShipmentBoxIds = new Set<string>();
  }

  populateSenders() {
    this.masterDataService.getMapOfSenders(this.selectedLabId, true).subscribe(
      result => {
        if (result.data) {
          Object.entries(result.data).forEach(([key]) => {
            this.senderList.push({ label: key, value: key });
            this.senderList.sort((a, b) => a.label.localeCompare(b.label))
            if(result.data[key] && result.data[key].boxBarcodeFormat){
              this.senderBarcodeMap.set(key, result.data[key].boxBarcodeFormat);
            }
          });
        }
      },
    );
  }

  getWorkFlowList(){
    this.masterDataService.getAllActiveWorkFlow(this.selectedLabId).subscribe(results =>{
      this.workFlowData = results.data;
      this.selectedWorkFlowData = this.workFlowData.filter(e=> e.displayName === 'Royal Canine - Reception' );
    },
    (error: any) => {
      let message = this.errorHandler.handleError(error);
      this._messagesService.addErrorMessage(message);
    });
  }

  clear() {
    this.selectedSender = null;
    this.boxID = '';
  }

  onTabChange(event) {
    switch (event.index) {
      case 0:
        break
      case 1:
        this.boxIdValidated = false;
        break
      case 2:
        break;

      default:
        break;
    }
    this.index = event;
  }

  validateAndSubmit(){
    if(this.selectedWorkFlowData.length == 0){
      this._messagesService.addWarningMessage({
        severity: 'error', summary: 'No WorkFlow Found', detail: 'Please Configure Royal Canine - Reception WorkFlow'
      });
      this.clear();
      return;
    }
    let deliveryId=this.boxID.trim();
    if(this.scannedShipmentBoxIds.has(deliveryId)){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Already scanned', detail: 'This box is already scanned'
      });
      this.clear();
    }
    else{
        this.blocked = true;
        this.deliveryService.validateBox(deliveryId).subscribe(
        result => {
          this.deliveryBox = result.data;
          switch(this.deliveryBox.httpStatus){
            case 200: {               
               this._messagesService.addSuccessMessage({
                    severity: 'success', summary: 'Delivery ID Validated!',
                    detail: 'Delivery ID ' + deliveryId + ' is valid.',
                });
                let box = new DeliveryBoxReception();
                box.lab=this.selectedLabId;
                box.labName = this.selectedLabName;
                box.workFlow= this.selectedWorkFlowData[0];
                box.puid=localStorage.getItem('PUID');
                box.sender='RCC';
                box.delivery=deliveryId;       
                box.receptionDateTime = new Date();       
                this.scannedShipmentBoxes.push(box);
                this.scannedShipmentBoxIds.add(deliveryId);
                this.clear();
                break;
          }
          case 404: {
            this._messagesService.addErrorMessage({
              severity: 'error', summary: this.deliveryBox.title,
              detail: this.deliveryBox.message
            })
            this.boxUpdateMessage = this.deliveryBox.message;
            this.clear();
            break;
          }
          case 409: {
            this._messagesService.addErrorMessage({
              severity: 'error', summary: this.deliveryBox.title,
              detail: this.deliveryBox.message
            })
            this.boxUpdateMessage = this.deliveryBox.message;
            this.clear();
            break;
          }
          default: {
            this._messagesService.addErrorMessage({
              severity: 'error', summary: this.deliveryBox.title,
              detail: this.deliveryBox.message
            })
          }
        
        
        }
        this.blocked = false;

        },
        error => {
          this.boxIdValidated = false;
          this.deliveryBox = new DeliveryBoxDetails();
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
          this.blocked = false;
        }
      );
    }
  }

  cloneBox(boxDetails: ShipmentBoxDetails): ShipmentBoxDetails{
    let sample = new ShipmentBoxDetails();
    for(let prop in boxDetails){
      sample[prop] = boxDetails[prop];
    }
    return sample;
  }

  deleteBoxFromList(deleteBoxID: string){
    if(this.scannedShipmentBoxIds.has(deleteBoxID))
      this.scannedShipmentBoxIds.delete(deleteBoxID);
    this.scannedShipmentBoxes = this.scannedShipmentBoxes.filter( ({ delivery }) => delivery !== deleteBoxID);
  }

  receptionComplete(){
    this.blocked = true;
    this.deliveryService.performBoxReception(this.scannedShipmentBoxes).subscribe(
      result => {
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Box reception successful',
          detail: 'Reception has been completed for boxes which were present in the table'
        })
        this.scannedShipmentBoxes = [];
        this.scannedShipmentBoxIds.clear();
        this.blocked = false;
      },
      error => {        
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
        this.blocked = false;
      }
    );
  }

  regexMatcher(regex: string, barcode: string): boolean {
    let regexp = new RegExp(regex);
    return regexp.test(barcode);
  }
 
}
